import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import useDiaboloData from "../hooks/useDiaboloData";

const TradeItem = (props) => (
  <div className="item">
    {/*<div className="exchange" style={{ color: "#"+props.textColor }}>{props.echange_name}</div>*/}
    <div className="exchange" style={{ color: "#" + props.textColor }}>
      Last trades
    </div>
    <div className="trader" style={{ color: "#" + props.textColor }}>
      {props.trader_username}
    </div>
    <div className="date" style={{ color: "#" + props.textColor }}>
      {props.human_date.substring(0, 10)}
    </div>
    {/*<div className="side" style={{ color: "#"+props.textColor }}>{props.position_side}</div>*/}
    <div className="paire" style={{ color: "#" + props.textColor }}>
      {props.paire}
    </div>
    <div className="change success">
      +{parseFloat((props.perf - 1) * 100).toFixed(0)}%
    </div>

    <a
      className="copy"
      target="_blank"
      href="https://app.diabolo.io"
      style={{ color: "#" + props.textColor }}
    >
      Copy
    </a>
  </div>
);

const TradesList = () => {
  const { diaboloData, isLoading } = useDiaboloData();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQuery();

  const [textColor, setTextColor] = useState("fafafa");
  const [backgroundColor, setBackgroundColor] = useState("1e2329");

  useEffect(() => {
    if (query.get("textColor")) {
      setTextColor(query.get("textColor"));
    }
    if (query.get("backgroundColor")) {
      setBackgroundColor(query.get("backgroundColor"));
    }
  }, [query]);

  function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
      let id = setInterval(() => {
        savedCallback.current();
      }, delay);
      return () => clearInterval(id);
    }, [delay]);
  }

  const [trade, setTrade] = useState(0);

  useInterval(() => {
    if (trade + 1 >= diaboloData.length) {
      setTrade(0);
    } else {
      setTrade(trade + 1);
    }
  }, 5000);

  return (
    <div>
      {!isLoading ? (
        <>
          {diaboloData && (
            <div
              className="container"
              style={{ background: "#" + backgroundColor }}
            >
              <TradeItem
                textColor={textColor}
                backgroundColor={backgroundColor}
                {...diaboloData[trade]}
              />
            </div>
          )}
        </>
      ) : (
        <>
          {/*<div className="container">
          <p className="loading-text">Loading Data...</p>
        </div>*/}
        </>
      )}
    </div>
  );
};

export default TradesList;
